// Gsap animation for logos Desktop
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 749) {
    const columns = document.querySelectorAll(".Count_loops_new .swiper-wrapper");

    const group13 = [columns[0], columns[2]].filter(Boolean);
    const group24 = [columns[1], columns[3]].filter(Boolean);

    const tl = gsap.timeline({ repeat: -1 });

    gsap.set(columns, { yPercent: 0 });

    function slideWithBounce(targets, toYPercent, direction = "up", delay = 0) {
      let bounceOffset = direction === "up" ? toYPercent - 5 : toYPercent + 5;

      tl.to(targets, {
        yPercent: bounceOffset,
        duration: 0.8, // slower main movement
        ease: "power3.out",
        delay: delay,
      });
      tl.to(targets, {
        yPercent: toYPercent,
        duration: 0.4, // smoother settle
        ease: "power2.out",
      });
    }

    // increased delay between transitions for breathing space
    slideWithBounce(group13, -100, "up", 1.2);
    slideWithBounce(group24, -100, "up", 1.2);
    slideWithBounce(columns, 0, "down", 1.2);
  }


  if (window.innerWidth <= 749) {
    const columns = document.querySelectorAll(".Count_loops_new .swiper-wrapper");
  
    const group03 = [columns[0], columns[3]].filter(Boolean);
    //console.log({group03})
    const group12 = [columns[1], columns[2]].filter(Boolean);
    //console.log({group12})
    const tl = gsap.timeline({ repeat: -1 });
  
    gsap.set(columns, { yPercent: 0 });
  
    function slideWithBounce(targets, toYPercent, direction = "up", delay = 0) {
      let bounceOffset = direction === "up" ? toYPercent - 5 : toYPercent + 5;
  
      tl.to(targets, {
        yPercent: bounceOffset,
        duration: 0.8,
        ease: "power3.out",
        delay: delay,
      });
      tl.to(targets, {
        yPercent: toYPercent,
        duration: 0.4,
        ease: "power2.out",
      });
    }
    
    slideWithBounce(group03, -100, "up", 1.2);
  
    slideWithBounce(group12, -100, "up", 1.2);

    slideWithBounce(columns, 0, "down", 1.2);
  
  }
});
